import { render, staticRenderFns } from "./sztd.vue?vue&type=template&id=3a21c05f&scoped=true"
import script from "./sztd.vue?vue&type=script&lang=js"
export * from "./sztd.vue?vue&type=script&lang=js"
import style0 from "./sztd.vue?vue&type=style&index=0&id=3a21c05f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21c05f",
  null
  
)

export default component.exports